import { Link } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import Reveal from '../../../shared/Reveal/Reveal';
import { useHomeWhatWeDoContent } from '../../../../hooks/useHomeWhatWeDoContent';
import './WhatWeDo.css';

const WhatWeDo = () => {
  const { content, isLoading } = useHomeWhatWeDoContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, rows } = content;

  return (
    <section className="what-we-do">
      <div className="what-we-do__inner">
        <Reveal className="what-we-do__header">
          <p className="what-we-do__eyebrow">{eyebrow}</p>
          <h2 className="what-we-do__title">{title}</h2>
        </Reveal>

        <div className="what-we-do__rows">
          {rows.map(({ title: rowTitle, description, image, icon, to, reverse }, index) => (
            <Reveal
              key={rowTitle}
              className={`what-we-do__row ${reverse ? 'what-we-do__row--reverse' : ''}`}
              delay={index * 100}
            >
              <article className="what-we-do__media">
                <img
                  className="what-we-do__media-image"
                  src={image}
                  alt=""
                  aria-hidden="true"
                />
                <div className="what-we-do__media-overlay" />
                <div className="what-we-do__media-content">
                  <div className="what-we-do__icon-wrap">
                    <img src={icon} alt="" aria-hidden="true" />
                  </div>
                  <p className="what-we-do__media-text">{description}</p>
                </div>
              </article>

              <article className="what-we-do__panel">
                <h3 className="what-we-do__panel-title">{rowTitle}</h3>
                <Link to={to} className="what-we-do__panel-link">
                  Learn more
                  <HiArrowRight className="what-we-do__panel-link-icon" aria-hidden="true" />
                </Link>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
